/* http://keith-wood.name/more.html
   Text truncation and show more for jQuery v2.0.0.
   Written by Keith Wood (kwood{at}iinet.com.au) May 2010.
   Available under the MIT (https://github.com/jquery/jquery/blob/master/MIT-LICENSE.txt) license. 
   Please attribute the author if you use it. */

(function (window, angular, $) {
    'use strict';

    moreDirective.$inject = ['$sce'];
    function moreDirective($sce) {

        var defaultOptions = {
            toggle: true, // True to toggle, false to display and exit
            length: 100, // Truncation length
            leeway: 5, // Overrun allowed without truncation
            wordBreak: true, // True to break between words, false to break anywhere
            ignoreTags: ['br', 'hr', 'img'], // Non-terminated tags to ignore
            ellipsisText: '...', // Display text for ellipsis
            moreText: 'more', // Display text for more link
            lessText: 'less', // Display text for less link
            ellipsisClass: 'more-ellipsis', // The ellipsis marker class
            linkClass: 'more-link', // The link marker class
            hiddenClass: 'more-hidden', // The text hidden marker class
            onChange: function() { } // Callback function when expanded/collapsed
        };

        function bindWatch(elem, options, value) {

            var tagName = /^<(\w+).*>$/; // Extract a tag name
            var text = $sce.getTrustedHtml(value) || '';

            if (text.length <= options.length + options.leeway) { // If text is shorter than max

                elem.html(text);

            } else {

                var matches = text.match(/(<[^>]+>)|([^<]+)/g); // Extract text and tags
                var i = 0;
                var pos = 0;
                var tags = [];
                for (; i < matches.length; i++) {
                    if (matches[i][0] === '<') { // A tag
                        if (matches[i][1] === '/' || matches[i][matches[i].length - 2] === '/') {
                            tags.pop(); // Closing
                        }
                        else if ($.inArray(matches[i].toLowerCase().replace(tagName, '$1'),
								options.ignoreTags) === -1) {
                            tags.push(matches[i]); // Opening
                        }
                    }
                    else if (pos + matches[i].length > options.length) { // Found truncation point
                        break;
                    }
                    else { // Count text
                        pos += matches[i].length;
                    }
                }

                pos = options.length - pos; // Split point
                if (options.wordBreak) { // Move back to start of word
                    var matched = matches[i].substring(0, pos + 1).replace('\n', ' ').match(/^.*\W/m);
                    pos = (matched ? matched[0].length - 1 : pos);
                }

                var closeTags = function (tags) { // Close any opened tags
                    var html = '';
                    for (var i = tags.length - 1; i >= 0; i--) {
                        html += '</' + tags[i].replace(tagName, '$1') + '>';
                    }
                    return html;
                };

                // Generate new content
                var html = matches.slice(0, i).join('') + matches[i].substring(0, pos) + closeTags(tags) +
					'<span class="' + options.ellipsisClass + '">' + options.ellipsisText + '</span>' +
					'<span style="display:none;" class="' + options.hiddenClass + '">' + tags.join('') +
					matches[i].substring(pos) + closeTags(tags) + matches.slice(i + 1).join('') + '</span>' +
					'<a href="#" class="' + options.linkClass + '">' + options.moreText + '</a>';

                elem.html(html).find('a.' + options.linkClass).click(function (event) {
                    var link = $(this);
                    var expanding = link.html() === $('<div>').html(options.moreText).text();
                    link.html(expanding ? options.lessText : options.moreText)
						.siblings('span.' + options.ellipsisClass + ',span.' + options.hiddenClass).toggle();
                    elem.parents('body').addClass('z').removeClass('z');
                    if (!options.toggle) { // Once only
                        link.remove();
                    }
                    if ($.isFunction(options.onChange)) { // Callback
                        options.onChange.apply(elem, [expanding]);
                    }
                    event.stopPropagation();
                    return false;
                });
            }
        }

        return function(scope, element, attr) {
            var expression = attr.more;
            element.addClass('ng-binding').data('$binding', expression);

            var options = angular.copy(defaultOptions);
            options.length = (attr.maxlength || defaultOptions.length) - 0;
            options.leeway = (attr.leeway || defaultOptions.leeway) - 0;
            options.ellipsisText = attr.ellipsisText || defaultOptions.ellipsisText;
            options.moreText = attr.moreText || defaultOptions.moreText;
            options.lessText = attr.lessText || defaultOptions.lessText;
            options.wordBreak = attr.wordBreak === 'true' || defaultOptions.wordBreak;

            scope.$watch(expression, angular.bind(this, bindWatch, element, options));
        };
    }

    angular.module('components.more', [])
        .directive('more', moreDirective);

})(window, window.angular, window.jQuery);